<template>
    <div>
        <!-- Collection of modals used in dashboard page -->

        <!-- Patient case details -->
        <v-dialog v-model="showCaseDetails" persistent max-width="800px">
            <CaseDetailsCard></CaseDetailsCard>
        </v-dialog>

        <!-- Assigning of case to doctor -->
        <base-confirmation-dialog
            v-model="showAssignCaseToDoctor"
            @cancel="cancelAssignCaseToDoctor"
            @confirm="confirmAssignCaseToDoctor"
        >
            <div
                class="text-h5 font-weight-regular text-center"
            >
                <p>
                    Do you want to add this case to
                    <span class="primary--text">
                        Dr. {{ selectedDoctor.name }}
                    </span>
                    ?
                </p>
            </div>
        </base-confirmation-dialog>
        
        <v-dialog v-model="showCreateCasePMS" persistent max-width="900px">
            <CreatePMSCaseCard></CreatePMSCaseCard>
        </v-dialog>
        <!-- <v-dialog v-model="showPatientPMSCase" persistent max-width="900px">
            <PatientCaseDetails></PatientCaseDetails>
        </v-dialog> -->

        <v-dialog v-model="showAssignCaseToDoctorList" persistent max-width="900px">
            <AssignCaseToDoctorCard></AssignCaseToDoctorCard>
        </v-dialog>

    </div>
</template>

<script>
import DASHBOARD_STORE from "../store/dashboard.module";
import API from "@/api"
const Consultations = API.get("Consultation");
const Case = API.get("Cases");


export default {
    components: {
        CaseDetailsCard: () => import("./CaseDetailsCard"),
        CreatePMSCaseCard: () => import("../case/cards/CreatePMSCaseCard"),
        // PatientCaseDetails: () => import("../case/cards/PatientCaseDetails")
        AssignCaseToDoctorCard: () => import("../case/cards/AssignCaseToDoctorCard")
    },
    computed: {
        showCaseDetails: function() {
            return DASHBOARD_STORE.getters.showCaseDetails;
        },
        showAssignCaseToDoctor: {
            get() {
                return DASHBOARD_STORE.getters.showAssignCaseToDoctor;
            },
            set() {
                return DASHBOARD_STORE.getters.showAssignCaseToDoctor;
            }
        },
        selectedCase: function() {
            return DASHBOARD_STORE.getters.selectedCase;
        },
        selectedDoctor: function() {
            return DASHBOARD_STORE.getters.selectedDoctor;
        },
        showCreateCasePMS: function() {
            return DASHBOARD_STORE.getters.showCreateCasePMS;
        },
        showAssignCaseToDoctorList: function() {
            return DASHBOARD_STORE.getters.showAssignCaseToDoctorList;
        },
        // showPatientPMSCase: function() {
        //     return DASHBOARD_STORE.getters.showPatientPMSCase;
        // }
    },
    methods: {
        cancelAssignCaseToDoctor() {
            DASHBOARD_STORE.commit("showAssignCaseToDoctor", false);
        },

        async confirmAssignCaseToDoctor() {
            console.log("doctor assignment api call");
            let selectedCase = DASHBOARD_STORE.getters.selectedCase;
            let selectedDoctor = DASHBOARD_STORE.getters.selectedDoctor;

            let form = {
                case_number: selectedCase.case_number,
                doctor_id: selectedDoctor.full_data.id,
                status: "ongoing"
            };

            console.log("form");
            console.log(form);
            console.log(selectedCase.consultations);
            console.log(selectedCase);

            Promise.all([
                    Consultations.update(selectedCase.consultations[0].id, form),
                    Case.update(selectedCase.id, form)
                ])
                .then(() => {
                    console.log("doctor assignment api call successful");
                    let cases = DASHBOARD_STORE.getters.cases;

                    let removeCaseIndex = cases.findIndex(item => item.id == selectedCase.id);

                    DASHBOARD_STORE.commit("removeToCases", {
                        index: removeCaseIndex
                    });

                    DASHBOARD_STORE.dispatch("setSelectedCase", {});
                    DASHBOARD_STORE.dispatch("setSelectedDoctor", {});
                })
                .finally(() => {
                    DASHBOARD_STORE.commit("showAssignCaseToDoctor", false);
                    DASHBOARD_STORE.commit("showAssignCaseToDoctorList", false);
                });
        }
    },
    mounted() {

    }
}
</script>